import React, { useState } from "react";
import { Input, Label } from "reactstrap";

import SearchIcon from "@areas/shared/components/icons/Search";

import searchStyles from "./styles/checkboxFilterGroup.module.css";

function CheckboxFilterGroup({
  styles,
  name,
  title,
  options = [],
  values = [],
  defaultOpen = false,
  onChange,
}) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const [search, setSearch] = useState("");

  const isChecked = (value) =>
    values.some((p) => p.name === name && p.value === value);

  const query = search.trim().toLowerCase();
  const filteredOptions = query
    ? options.filter(
        (item) =>
          isChecked(item.Value) ||
          (item.Name || "").toLowerCase().includes(query)
      )
    : options;

  return (
    <div
      className={`${styles.checkboxGroup}${isOpen ? ` ${styles.active}` : ""}`}
    >
      <div
        className={styles.checkboxGroupHeader}
        onClick={() => setIsOpen((open) => !open)}
      >
        {title}
      </div>
      <div
        className={
          isOpen ? searchStyles.optionsSearchOpen : searchStyles.optionsSearch
        }
        onClick={(e) => e.stopPropagation()}
      >
        <SearchIcon
          style={searchStyles.icon}
          gradientId={`filterSearch-${name}`}
          gradientSteps={[
            { offset: 0, stopColor: "#0072FF" },
            { offset: 1, stopColor: "#29CD8F" },
          ]}
        />
        <input
          type="text"
          className={searchStyles.input}
          placeholder="Поиск"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onClick={(e) => e.stopPropagation()}
        />
        {search ? (
          <button
            type="button"
            className={searchStyles.clear}
            aria-label="Очистить поиск"
            onClick={(e) => {
              e.stopPropagation();
              setSearch("");
            }}
          >
            ×
          </button>
        ) : null}
      </div>
      {filteredOptions.length === 0 ? (
        <div className={`${styles.option} ${searchStyles.empty}`}>
          Ничего не найдено
        </div>
      ) : (
        filteredOptions.map((item, index) => (
          <div key={`${item.Value}-${index}`} className={styles.option}>
            <Input
              id={`${name}-${item.Value}-${index}`}
              type="checkbox"
              className={styles.checkbox}
              name={name}
              value={item.Value || ""}
              defaultChecked={isChecked(item.Value)}
              onChange={() => onChange(name, item.Value)}
            />
            <Label
              className={styles.checkboxLabel}
              htmlFor={`${name}-${item.Value}-${index}`}
            >
              {item.Name}
            </Label>
          </div>
        ))
      )}
    </div>
  );
}

export default CheckboxFilterGroup;
